import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ReportPreferenceApi } from '../api/report-preference.api';
import { ReportPreference } from '@ps/user-settings-models';

@Injectable({ providedIn: 'root' })
export class ReportPreferenceService {
  private readonly _api = inject(ReportPreferenceApi);

  public getReportPreference(userId: number): Observable<ReportPreference[]> {
    return this._api.getReportPreference(userId);
  }

  public saveReportPreference(
    userId: number,
    preferences: ReportPreference[],
  ): Observable<number[]> {
    return this._api.saveReportPreference(userId, preferences);
  }
}
